// NPM Imports
import React from "react";

// Chart Imports
import FusionCharts from "fusioncharts";
import Charts from "fusioncharts/fusioncharts.charts";
import ReactFC from "react-fusioncharts";
import FusionTheme from "fusioncharts/themes/fusioncharts.theme.fusion";

// Internal Imports
import { DASHBOARD } from "../../../../constants";

// Adding the chart and theme as dependency to the core fusioncharts
ReactFC.fcRoot(FusionCharts, Charts, FusionTheme);

// Destructuring
const { PIE_CHART_CONFIGS } = DASHBOARD;

/**
 * :: PieChart ::
 * (for showing the data in Pie Chart format with chart type 'doughnut2d'),
 *  - uses const 'PIE_CHART_CONFIGS'  which includes the base configurations for chart
 *  - need to pass the followings props,
 *    1. 'chart'   - chart related configs
 *    2. 'data'    - array of objects
 *    3. 'width'   - chart container width
 *    4. 'height'  - chart container height
 *  - for more details 'https://www.fusioncharts.com/dev/chart-attributes/pie2d'
 */
const PieChart = props => {
  const {
    width,
    height,
    configs: { chart, data },
  } = props;

  const getChartConfigs = () => {
    const chartConfigs = JSON.parse(JSON.stringify(PIE_CHART_CONFIGS));
    chartConfigs.width = width;
    chartConfigs.height = height;
    chartConfigs.dataSource = {
      ...chartConfigs.dataSource,
      chart: {
        ...chartConfigs.dataSource.chart,
        ...chart,
      },
      data,
    };
    return chartConfigs;
  };

  return <ReactFC {...getChartConfigs()} />;
};

export default PieChart;



// WEBPACK FOOTER //
// ./src/components/DashboardWrapper/Charts/PieChart/index.js